import React, { useState } from 'react';
import { Input, Form, Row, Col, Radio } from 'antd';
import { DrawerEdit, FormItemWrap } from '@unicus/react-ui-kit';
import { ResCol } from 'components';
import { federalTaxNumberValidator } from 'util/validators';
import { MaskedInput } from 'antd-mask-input';

const SupplierEdit = (props) => {
  const [isLegalPerson, setIsLegalPerson] = useState(false);

  const toggler = () => {
    setIsLegalPerson(!isLegalPerson);
  };

  const handleSubmit = ({ address, ...rest }) => {
    return {
      ...rest,
      isLegalPerson
    };
  };

  const handleBeforeBinding = ({ ...rest }) => {
    setIsLegalPerson(rest.isLegalPerson ?? false);

    return {
      ...rest
    };
  };

  return (
    <DrawerEdit
      {...props}
      size="sm"
      onSubmit={handleSubmit}
      onBeforeBinding={handleBeforeBinding}
    >
      <Form layout="vertical">
        <Row justify="center">
          <Col>
            <Radio.Group
              value={isLegalPerson}
              onChange={toggler}
              disabled={props.data.integrated}
            >
              <Radio.Button value={false}>Pessoa Física</Radio.Button>
              <Radio.Button value>Pessoa Jurídica</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>

        <Row>
          <ResCol span={9}>
            <FormItemWrap
              name="federalTaxNumber"
              label={isLegalPerson ? 'CNPJ' : 'CPF'}
              required
              whitespace
              autoFocus
              validateTrigger=""
              rules={[{ validator: federalTaxNumberValidator }]}
            >
              <MaskedInput
                mask={isLegalPerson ? '11.111.111/1111-11' : '111.111.111-11'}
                disabled={props.data.integrated}
              />
            </FormItemWrap>
          </ResCol>

          <ResCol span={15}>
            <FormItemWrap
              name="name"
              label={isLegalPerson ? 'Razão Social' : 'Nome'}
              required
              whitespace
              validateTrigger="onBlur"
            >
              <Input maxLength={80} disabled={props.data.integrated} />
            </FormItemWrap>
          </ResCol>
        </Row>

        <Row>
          <ResCol span={10}>
            <FormItemWrap label="E-mail" name="email" type="email">
              <Input maxLength={50} />
            </FormItemWrap>
          </ResCol>

          <ResCol span={7}>
            <FormItemWrap label="Telefone" name="phoneNumber">
              <MaskedInput
                mask="(11) 1111-1111"
                placeholder="(__) _____-____"
              />
            </FormItemWrap>
          </ResCol>

          <ResCol span={7}>
            <FormItemWrap label="Celular" name="mobileNumber">
              <MaskedInput
                mask="(11) 11111-1111"
                placeholder="(__) ______-____"
              />
            </FormItemWrap>
          </ResCol>
        </Row>
      </Form>
    </DrawerEdit>
  );
};
export default SupplierEdit;
